<template>
    <v-card class="form-title">
        <v-row class="form-title-details ma-0">
            <v-col class="text-center text-sm-left" cols="12" sm="7" md="7" lg="7">
                <v-row>
                    <v-icon color="primary" class="hidden-xs-only form-title-icon">edit</v-icon>
                    <v-row class="ma-0">
                        <h2 class="form-title-heading">{{ title }}</h2>
                        <span class="form-title-subheading">{{ description }}</span>
                    </v-row>
                </v-row>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="text-center text-sm-right" cols="12" sm="5" md="5" lg="5">
                <slot name="actions" />
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    name: 'FormTitle',
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss">
.form-title {
    .form-title-details {
        padding: 1rem;
        align-items: center;

        .form-title-icon {
            font-size: 2rem;
            margin-right: 15px;
        }

        .form-title-heading {
            font-weight: 500;
        }

        .form-title-subheading {
            color: gray;
        }
    }
}
</style>
